"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarGrid = CalendarGrid;
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("../../../../components/text/Text"));
var _date = require("@internationalized/date");
var _calendar = require("@react-aria/calendar");
var _Calendar = require("./Calendar.styled");
var _CalendarCell = require("./CalendarCell");
var _jsxRuntime = require("react/jsx-runtime");
function shouldHighlight(highlightToday, date) {
  return highlightToday && (0, _date.today)((0, _date.getLocalTimeZone)()).compare(date) === 0;
}
function getDateInterval(visibleRangeStart, offset) {
  var startDate = (0, _date.toCalendarDate)(visibleRangeStart.add(offset));
  var endDate = (0, _date.toCalendarDate)((0, _date.endOfMonth)(startDate));
  return {
    startDate: startDate,
    endDate: endDate
  };
}
function CalendarGrid(_ref) {
  var state = _ref.state,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? {} : _ref$offset,
    _ref$highlightToday = _ref.highlightToday,
    highlightToday = _ref$highlightToday === void 0 ? false : _ref$highlightToday;
  var dateInterval = getDateInterval(state.visibleRange.start, offset);
  var _ref2 = (0, _calendar.useCalendarGrid)(dateInterval, state),
    gridProps = _ref2.gridProps,
    headerProps = _ref2.headerProps,
    weekDays = _ref2.weekDays; // Always show 6 weeks to avoid jumping when switching months
  var weeksToShow = 6;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", _objectSpread({}, gridProps, {
    cellPadding: "0",
    cellSpacing: "0",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("thead", _objectSpread({}, headerProps, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
        children: weekDays.map(function (day, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("th", {
            align: 'center',
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar.CalendarHeaderCellWrapper, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                children: day
              })
            })
          }, index);
        })
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
      children: _toConsumableArray(new Array(weeksToShow).keys()).map(function (weekIndex) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
          children: state.getDatesInWeek(weekIndex, dateInterval.startDate).map(function (date, i) {
            return date ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CalendarCell.CalendarCell, {
              state: state,
              date: date,
              currentMonth: dateInterval.startDate,
              highlight: shouldHighlight(highlightToday, date)
            }, i) : /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {}, i);
          })
        }, weekIndex);
      })
    })]
  }));
}